/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-search': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd"><g transform="translate(8 8)" _fill="#00272E" fill-rule="nonzero"><path pid="0" d="M15.615 13.733l-3.374-3.416a6.66 6.66 0 10-1.876 1.896l3.353 3.395a1.352 1.352 0 001.886.01 1.333 1.333 0 00.011-1.885zM6.667 1.17a5.5 5.5 0 11-5.5 5.5 5.507 5.507 0 015.5-5.5z"/><circle pid="1" cx="6.667" cy="6.67" r="4.5"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-search.js